import { Fragment, ReactElement } from 'react';
import ResearchMarriageNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage';

const ResearchMarriageNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageNotificationsCivilStatusShared />
    </Fragment>
  );
};

ResearchMarriageNotificationsCivilStatusPage.displayName =
  'Research Marriage Notifications CivilStatusPage component';

export default ResearchMarriageNotificationsCivilStatusPage;
